import { render, staticRenderFns } from "./TabelaAtualizacao.vue?vue&type=template&id=fe7c9de0"
import script from "./TabelaAtualizacao.vue?vue&type=script&lang=js"
export * from "./TabelaAtualizacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaAtualizacao.vue?vue&type=style&index=0&id=fe7c9de0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports